import { Grid, Typography } from '@material-ui/core';
import React, { useState } from 'react';
import KenDialog from '../../../global_components/KenDialogBox';
import KenSelectWrap from '../../../global_components/KenSelect';
import KenDateTimePicker from '../../../global_components/KenDateTimePicker';
import { makeStyles, withStyles } from '@material-ui/styles';
import { updateReferenceActivities } from '../../../Utils/apiServices';
import { useAppContext } from '../../../Utils/context';

// style
const useStyles = makeStyles((theme) => ({
  breadCrumbWrapper: {
    margin: '15px 0',
  },

  header: {
    background: '#ffffff',
    color: theme.palette.KenColors.primary,
  },
  actionBtn: {
    // margin: '0 10 px',
    float: 'right',
  },
  title: {
    fontSize: 18,
    fontWeight: 600,
  },
  popOverTitle: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#ffffff',
    backgroundColor: '#092682',
    fontSize: '14px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  holidayButton: {
    textTransform: 'none',
    fontWeight: 'bold',
    marginRight: '5px',
  },
  fitlerButton: {
    textTransform: 'none',
    fontWeight: 'bold',
  },
  sortingSection: {
    display: 'grid',
    gap: '10px',
    gridTemplateColumns: 'repeat(7, 1fr)',
  },
  popOverData: {
    width: '216px',
    minWidth: '200px',
    height: '27px',
    color: '#092682',
    fontSize: '12px',
    fontWeight: '600',
    padding: '3px 15px',
  },
  mainActions: {
    textAlign: 'right',
  },
  popOverHeading: {
    width: '100%',
    fontSize: '14px',
    fontWeight: '400',
    color: '#02195E',
  },
  tableBodyStyle: {
    fontSize: '12px',
    color: '#7A869A',
  },
  tableBodyStyleIgnoreHoliday: {
    fontSize: '12px',
    color: '#7A869A',
    padding: '0px',
  },
  textInputFieldDropDown: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  textInputField: {
    background: 'transparent',
    borderRadius: '4px',
    color: '#000',
  },
  kenDateTimePickerColor: {
    backgroundColor: '#fff',
  },
  noDataFound: {
    fontWeight: '600',
    fontSize: '14px',
  },
  filterButton: {
    marginRight: '10px',
  },
}));
// Add and Edit Reference Dialogue
const Reference = ({
  title,
  children,
  isOpen,
  handleClose,
  handleEvent,
  positiveBtn,
  negativeBtn,
  activityTypes,
  subjects = [],
  facultyOptions,
  event = {},
  onSuccess,
  termId,
}) => {
  const classes = useStyles();

  const {
    id,
    startDate: eStartDate = '',
    endDate: eEndDate = '',
    faculty1Id = '',
    faculty2Id = '',
    faculty3Id = '',
    activityType = '',
    subjectId = '',
  } = event || {};

  const { handleLoader } = useAppContext();

  // all State
  const [activityValue, setActivityValue] = useState(activityType);
  const [startDate, setStartDate] = useState(eStartDate);
  const [endDate, setEndDate] = useState(eEndDate);
  const [facultyName, setFacultyName] = useState(faculty1Id);
  const [facultyNameTwo, setFacultyNameTwo] = useState(faculty2Id);
  const [facultyNameThree, setFacultyNameThree] = useState(faculty3Id);
  const [selectSubjectValue, setSelectSubjectValue] = React.useState(subjectId);

  console.log('id-------------', id);
  // all methods
  const handleSelectProgramChange = (e, value) => {
    setActivityValue(e.target.value);
  };

  const handleChangedStartDate = (e) => {
    setStartDate(e.target.value);
  };

  const handleChangedEndDate = (e) => {
    setEndDate(e.target.value);
  };
  const handleSelectFacultyChange = (e, value) => {
    setFacultyName(e.target.value);
  };

  const handleSelectFacultyTwoChange = (e, value) => {
    setFacultyNameTwo(e.target.value);
  };

  const handleSelectFacultyThreeChange = (e, value) => {
    setFacultyNameThree(e.target.value);
  };
  const handleSelectSubject = (e) => {
    setSelectSubjectValue(e.target.value);
  };

  const handleAddEventRefernce = async () => {
    const objRef = {
      Operation: 'Create',
      Activity: {
        termId: termId,
        facultyIds: [facultyName, facultyNameTwo, facultyNameThree]
          .filter((f) => f)
          .join(';'),
        courseVersionId: selectSubjectValue,
        activityId: id || '',
        activityType: activityValue,
        activityStartDate: `${startDate}T00:00:00.000Z`,
        activityEndDate: `${endDate}T00:00:00.000Z`,
        // activityEndDate: '2022-06-30T00:00:00.000Z',  // date formate use to send
      },
    };

    console.log(objRef);

    handleLoader(true);
    updateReferenceActivities(objRef)
      .then((res) => {
        handleLoader(false);
        // Toast ("Updated Successfully",{variant:'success})
        onSuccess();
      })
      .catch((err) => {
        handleLoader(false);
        console.log(err);
      });
  };
  return (
    <div>
      {' '}
      <KenDialog
        title={
          <Typography variant="h6" className={classes.dialogHeader}>
            {<b>{title}</b>}
          </Typography>
        }
        open={isOpen}
        // icon={<RiCheckFill />}
        handleClose={handleClose}
        negativeButtonClick={
          handleClose
          // (e) => setConfirmDialogAdd(false)
        }
        positiveButtonClick={handleAddEventRefernce}
        positiveButtonText={id ? 'Update' : 'Create'}
        negativeButtonText={'Cancel'}
        dividers
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={12}>
            <KenSelectWrap
              // disabled={readOnly}
              label="Type of Activity"
              options={activityTypes}
              value={activityValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectProgramChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'startDate'}
              label="Start Date"
              // disabled={readOnly}
              value={startDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={handleChangedStartDate}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <KenDateTimePicker
              name={'endDate'}
              label="End Date"
              // disabled={readOnly}
              value={endDate}
              type="date"
              required={true}
              // defaultValue={startData}
              onChange={handleChangedEndDate}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Subject"
              options={subjects}
              // disabled={readOnly}
              value={selectSubjectValue}
              dropdownColor="#FFFFFF"
              onChange={handleSelectSubject}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty1"
              options={facultyOptions}
              value={facultyName}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty2"
              options={facultyOptions}
              value={facultyNameTwo}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyTwoChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <KenSelectWrap
              label="Faculty3"
              options={facultyOptions}
              value={facultyNameThree}
              dropdownColor="#FFFFFF"
              onChange={handleSelectFacultyThreeChange}
              // styles={CustomStyle}
              required
            />
          </Grid>
        </Grid>
      </KenDialog>
    </div>
  );
};

export default Reference;
